// export const front_end_domain = 'https://blissful-blackwell.43-242-226-140.plesk.page';
// export const baseUrl = 'https://blissful-blackwell.43-242-226-140.plesk.page';
// export const baseUrl = 'http://192.168.18.101:5000';
export const front_end_domain = 'http://globalhcubeservices.org';
export const baseUrl = 'http://globalhcubeservices.org';

